import { useClientVersion } from "@/hooks/general/useClientVersion";
import { ArrowPathIcon } from "@heroicons/react/24/outline";

/**
 * A banner component that shows when a new version is being loaded.
 * The app will auto-refresh, but this gives users visual feedback.
 */
export function UpdatePrompt() {
    const { isOutdated, isRefreshing, updateMessage } = useClientVersion();

    // Only show when we're about to refresh
    if (!isOutdated || !isRefreshing) {
        return null;
    }

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
            role="alert"
            aria-live="polite"
        >
            <div className="mx-4 max-w-md rounded-lg bg-slate-800 p-6 text-center shadow-xl">
                <ArrowPathIcon className="mx-auto h-12 w-12 animate-spin text-amber-500" />
                <h3 className="mt-4 text-lg font-semibold text-white">
                    Updating...
                </h3>
                <p className="mt-2 text-sm text-slate-300">
                    {updateMessage ||
                        "A new version is available. The page will refresh automatically."}
                </p>
            </div>
        </div>
    );
}
